
import Title from '../Title/Title';
import './Hardware.css';

function Hardware() {
  return (
    <div className="hardware" id='hardware'>
        <Title titleName="硬件产品" />
        <p className='hardware-desc wow fadeIn' data-wow-delay="0.3s">
          全平台硬件覆盖，灵活部署，多端适配，满足不同场景需求
        </p>
        <div className='hardware-list wow fadeInLeft' data-wow-delay="0.5">
          <div className='hardware-list-item'>
              <div>
                <div className='hardware-list-item-img x86'></div>
                <div className='hardware-list-item-title'>X86 服务器</div>
                <div className='hardware-list-item-sub'>高性能计算，支持虚拟化与多拨，稳定高效</div>
              </div>
          </div>
          <div className='hardware-list-item'>
              <div>
                <div className='hardware-list-item-img'></div>
                <div className='hardware-list-item-title'>电视盒子</div>
                <div className='hardware-list-item-sub'>低功耗部署，即插即用，适合家庭和小型节点</div>
              </div>
          </div>
          <div className='hardware-list-item'>
              <div>
                <div className='hardware-list-item-img router'></div>
                <div className='hardware-list-item-title'>路由器</div>
                <div className='hardware-list-item-sub'>小巧便携，边缘计算节点，覆盖更广</div>
              </div>
          </div>
          <div className='hardware-list-item'>
              <div>
                <div className='hardware-list-item-img camera'></div>
                <div className='hardware-list-item-title'>摄像头</div>
                <div className='hardware-list-item-sub'>IoT 设备接入，拓展更多终端形态</div>
              </div>
          </div>
        </div>
   </div>
  );
}

export default Hardware;
